import React from 'react';
import cn from 'classnames';
import Icon from 'components/common/Icon';

export default ({ icon, label, isHorizontal, wide, contained, large }) => {
  return (
    <div className={cn("icon-label", "d-flex", "align-items-center", { "flex-row": isHorizontal, "flex-column": !isHorizontal, contained, large })}>
      <div className={cn("icon-wrap", { "mb-2": !isHorizontal })}>
        <Icon icon={icon} />
      </div>
      <div className={cn({ "ml-1": isHorizontal, "wide": wide })}>{label}</div>
    </div>
  )
};


// WEBPACK FOOTER //
// ./src/components/common/IconLabel.js